var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCinegetica(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0039 15.9971V20.9971",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0039 2.99707V7.99707",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00391 11.9971H3.00391",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0039 11.9971H16.0039",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00391 11.9971C5.00391 12.9164 5.18497 13.8266 5.53676 14.6759C5.88854 15.5251 6.40415 16.2968 7.05416 16.9469C7.70418 17.5969 8.47585 18.1125 9.32513 18.4643C10.1744 18.8161 11.0847 18.9971 12.0039 18.9971C12.9232 18.9971 13.8334 18.8161 14.6827 18.4643C15.532 18.1125 16.3037 17.5969 16.9536 16.9469C17.6037 16.2968 18.1193 15.5251 18.4711 14.6759C18.8228 13.8266 19.0039 12.9164 19.0039 11.9971C19.0039 11.0778 18.8228 10.1676 18.4711 9.3183C18.1193 8.46901 17.6037 7.69734 16.9536 7.04733C16.3037 6.39731 15.532 5.88169 14.6827 5.52991C13.8334 5.17813 12.9232 4.99707 12.0039 4.99707C11.0847 4.99707 10.1744 5.17813 9.32513 5.52991C8.47585 5.88169 7.70418 6.39731 7.05416 7.04733C6.40415 7.69734 5.88854 8.46901 5.53676 9.3183C5.18497 10.1676 5.00391 11.0778 5.00391 11.9971Z",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCinegetica);
export default __webpack_public_path__ + "static/media/Cinegetica.609f91f642964c5a4d2ffd0888007d7b.svg";
export { ForwardRef as ReactComponent };